import BaseService from "services/base";
import { builder } from "utils/graphql";
import { SHOP_SELECTION } from "./constant";

class ShopService extends BaseService {
  name = "Shop";
  static override DEFINITION = builder.createDefinition({
    name: "Shop",
    baseQuery: "Shop",
    baseSelection: `
        ${SHOP_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
      UPDATE: `
        {{ selections }}
      `,
    },
    GQL_ACTIONS: {
      FIND: "Shops",
      CREATE: "createShop",
      UPDATE: "updateShop",
    },
    GQL_RESPONSE_DATA_PATH: {
      BASE: "data.Shop",
      FIND: "data.Shops.docs",
      UPDATE: "data.Shop",
      PARAMS: "data.Shops",
    },
  });
}
export * from "./constant";

const Instance = new ShopService();

export default Instance;
